export const RCR_ENDPOINT_DEFAULT = "https://rcr.tmca.rotorint.com/orchestrator";
export const RCR_API_KEY_DEFAULT = "public-client-project-id-8004";
